import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, AuthOrganization } from '../types';
import { revokeAuthenticatedStorageCache } from '../utils/authenticatedStorage';

interface AuthState {
  token: string | null;
  user: User | null;
  organization: AuthOrganization | null;
  isAuthenticated: boolean;
  setAuth: (token: string, user: User, organization: AuthOrganization) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      organization: null,
      isAuthenticated: false,

      setAuth: (token, user, organization) => {
        localStorage.setItem('auth_token', token);
        set({ token, user, organization, isAuthenticated: true });
      },

      clearAuth: () => {
        localStorage.removeItem('auth_token');
        // DQ-443: the command palette's "recent" list belongs to the signed-in user.
        try {
          for (let i = localStorage.length - 1; i >= 0; i--) {
            const k = localStorage.key(i);
            if (k && k.startsWith('ote_palette_recent')) localStorage.removeItem(k);
          }
        } catch { /* storage off */ }
        revokeAuthenticatedStorageCache();
        set({ token: null, user: null, organization: null, isAuthenticated: false });
      },
    }),
    {
      name: 'ote-auth-storage',
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        organization: state.organization,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
